module.exports = __webpack_public_path__ + "static/media/PlatformDifferences_Norsk.a34021b4.png";